import { Camera } from "lucide-react";
import { ASSETS } from "@/lib/site";

// Asymmetric gallery — 5 real photos + 1 placeholder (kept for future additions).
const TILES = [
  {
    span: "sm:col-span-2 sm:row-span-2 aspect-square sm:aspect-auto",
    src: ASSETS.gallery3,
    label: "Cabin at dusk",
    crop: "sh-crop-mobile-strong",
  },
  {
    span: "aspect-[4/5]",
    src: ASSETS.gallery4,
    label: "The path in",
    crop: "sh-crop-mobile-strong",
  },
  {
    span: "aspect-[4/5]",
    src: ASSETS.gallery5,
    label: "A-frame close-up",
    crop: "sh-crop-mobile",
  },
  {
    span: "aspect-[4/3] sm:col-span-2",
    src: ASSETS.gallery2,
    label: "Cabins in the mist",
    crop: "sh-crop-mobile",
  },
  {
    span: "aspect-square",
    src: ASSETS.gallery1,
    label: "Garden bench",
    crop: "sh-crop-mobile",
  },
  {
    span: "aspect-square",
    src: null,
    label: "More coming soon",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[color:var(--sh-charcoal)] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14 sh-reveal">
          <div>
            <div className="text-xs uppercase tracking-[0.35em] text-[color:var(--sh-amber)] mb-4">
              Gallery
            </div>
            <h2 className="sh-display text-[color:var(--sh-cream)] text-4xl sm:text-5xl lg:text-6xl font-medium max-w-3xl">
              A quiet look around.
            </h2>
          </div>
          <p className="text-[color:var(--sh-cream-dim)] max-w-sm text-sm sm:text-base">
            Fresh from Nathia Gali — morning fog, evening glow, and the pines in between.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-5 sh-reveal">
          {TILES.map((t, i) => (
            <figure
              key={i}
              data-testid={`gallery-tile-${i}`}
              className={`${t.span} relative rounded-2xl sm:rounded-3xl overflow-hidden group`}
            >
              {t.src ? (
                <>
                  <img
                    src={t.src}
                    alt={t.label}
                    loading="lazy"
                    className={`absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105 ${t.crop || "sh-crop-mobile"}`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-70 group-hover:opacity-90 transition-opacity" />
                  <figcaption className="absolute bottom-3 left-3 right-3 flex items-center gap-2 text-[10px] uppercase tracking-widest text-[color:var(--sh-cream)]">
                    <span className="w-4 h-px bg-[color:var(--sh-amber)]" />
                    {t.label}
                  </figcaption>
                </>
              ) : (
                <div className="sh-placeholder w-full h-full">
                  <span className="flex flex-col items-center gap-2 px-4 text-center">
                    <Camera size={18} className="text-[color:var(--sh-amber)]" strokeWidth={1.4} />
                    <span>Photo coming soon</span>
                    <span className="text-[10px] opacity-60">{t.label}</span>
                  </span>
                </div>
              )}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
